export const reportsFr = {
  title: "Administration",
  placeholder: "Rapports d'entreprises et bilan personnalisable.",
  tabs: {
    enterprises: "Entreprises",
    progress: "Progression",
    assessment: "Bilan personnalisable",
    search: "Recherche",
    partners: "Partenaires",
    promoCodes: "Codes promotionnels",
  },
  filters: {
    heading: "Filtres",
    keyword: "Mot-clé",
    keywordPlaceholder: "Mots-clés (nom, ville, etc.)",
    keywordPlaceholderProgress: "Mots-clés",
    region: "Région",
    allRegions: "Toutes les régions",
    mrc: "MRC",
    allMrcs: "Toutes les MRC",
    allCities: "Toutes les villes",
    allProvinces: "Toutes les provinces",
    partnerGroup: "Groupe partenaire",
    allPartnerGroups: "Tous les groupes",
    advanced: "Recherche avancée",
    province: "Province",
    dateFrom: "Date de début",
    dateTo: "Date de fin",
    dateOrder: "La date de début doit précéder ou être égale à la date de fin",
    monthPlaceholder: "mm/aaaa",
    sectorCategory: "Secteur d'activité",
    allCategories: "Tous les secteurs d'activité",
    sectors: "Sous-secteurs d'activité",
    allSectors: "Tous les sous-secteurs d'activité",
    answerType: "Type de réponse",
    allAnswerTypes: "Tous les types de réponse",
    issues: "Enjeux",
    allIssues: "Tous les enjeux",
    goals: "Objectifs",
    allGoals: "Tous les objectifs",
    actions: "Actions",
    allActions: "Toutes les actions",
    removeFilter: "Retirer le filtre",
    search: "Rechercher…",
    noMatch: "Aucun résultat",
    reset: "Réinitialiser",
    apply: "Appliquer",
  },
  columns: {
    name: "Nom",
    city: "Ville",
    region: "Région",
    partnerGroups: "Groupe partenaire",
    sectors: "Secteurs",
    type: "Type",
    currentStep: "Étape en cours",
    lastLogin: "Date dernière connexion",
    accountCreated: "Date création compte",
    contact: "Contact",
    email: "Courriel",
  },
  steps: {
    step_0: "Profil d'entreprise créé",
    step_1: "Questionnaire débuté",
    step_2: "Questionnaire complété",
    step_3: "Plan d'action créé",
    step_4: "Suivi plan d'action débuté",
    step_5: "Approbation demandée",
    step_6: "Communication publiée",
  },
  detail: {
    title: "Fiche d'entreprise",
    close: "Fermer",
    contact: "Coordonnées",
    owner: "Responsable",
    address: "Adresse",
    sectors: "Secteurs d'activité",
    characteristics: "Caractéristiques",
    companySize: "Nombre d'employés",
    consents: "Consentements",
    consentProgress: "Progrès",
    consentDiagnostic: "Autoévaluation",
    consentEdit: "Modification",
    granted: "Accordé",
    notGranted: "Non accordé",
    progress: "Progression",
    description: "Description",
    phone: "Téléphone",
    mrc: "MRC",
    account: "Compte",
    subscriptionStatus: "Statut d'abonnement",
    couponsUsed: "Bons de réduction utilisés",
    accountCreated: "Création du compte",
    lastLogin: "Dernière connexion",
    subStatus: {
      active: "Actif",
      incomplete: "Incomplet",
      incomplete_expired: "Incomplet expiré",
      past_due: "En souffrance",
      canceled: "Annulé",
      unpaid: "Impayé",
    },
    communication: "Communication",
    publicationStatus: "Statut de publication",
    pubNone: "Aucune demande",
    pubRequested: "Demande créée le {{date}}",
    pubPublished: "Approuvée et publiée le {{date}}",
    lastCommunication: "Dernière communication",
    actionPlans: "Plans d'action",
    untitledPlan: "Plan sans nom",
    relatedProfiles: "Profils du même groupe",
    none: "—",
  },
  assessment: {
    totalEnterprises: "Entreprises",
    signUps: "Inscriptions",
    signUpsPerMonth: "Inscriptions par mois",
    completedQuestionnaire: "Questionnaires complétés",
    completedActionPlan: "Plans d'action complétés",
    publishedCommunication: "Communications publiées",
    activeUsers: "Utilisateurs actifs",
    progression: "Progression",
    bySector: "Entreprises par secteur d'activité",
    byPartnerGroup: "Entreprises par groupe partenaire",
    byStep: "Répartition par étape",
    byThematic: "Pistes d'actions et réalisations",
    carriedOut: "Réalisations",
    courseOfAction: "Pistes d'action",
    drilldownHint: "Cliquez sur une ligne pour explorer : thématique → enjeu → objectif → action → entreprises.",
    progressionHint: "Cliquez sur une étape pour voir les entreprises qui s'y trouvent.",
    back: "Retour",
    levels: {
      thematic: "Thématiques",
      issue: "Enjeux",
      goal: "Objectifs",
      action: "Actions",
      enterprise: "Entreprises",
    },
  },
  search: {
    description:
      "Recherchez les entreprises par mots-clés et par leurs réponses au questionnaire (enjeux, objectifs, actions).",
  },
  csv: {
    export: "Exporter en CSV",
    exportProgress: "Exporter la progression",
    exportAssessment: "Exporter le bilan",
    failed: "L'exportation a échoué.",
  },
  state: {
    loading: "Chargement…",
    error: "Une erreur est survenue lors du chargement des données.",
    empty: "Aucune entreprise ne correspond aux filtres.",
    results_one: "{{count}} entreprise",
    results_other: "{{count}} entreprises",
    previous: "Précédent",
    next: "Suivant",
    page: "Page {{page}}",
  },
} as const;
